/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { GroupManagementListGroupResponse } from "./GroupManagementListGroupResponse";

export type GroupManagementListGroupResponseApiRespoonse = {
  data?: GroupManagementListGroupResponse;
  status?: GroupManagementListGroupResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace GroupManagementListGroupResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
